import {
  NeutralColorConfig,
  NeutralColorToken,
  setTheme,
} from '@aries/ui-theming';

const colorTextBase = {
  dark: '#e6e6ef',
  light: '#18192f',
};
const colorText = {
  dark: '#ffffff',
  light: '#000000',
};
const colorTextSecondary = {
  dark: '#adb8db',
  light: '#adb8db',
};
const colorTextTertiary = {
  dark: '#737b94',
  light: '',
};
const colorTextQuaternary = {
  dark: '#0f121c',
  light: '#000000',
};
const colorBgDefault = {
  dark: '#fff',
  light: '#000',
};
const colorBgBase = {
  dark: '#08090F',
  light: '#f8f9fc',
};
const colorBg = {
  dark: '#0F131F',
  light: '#e4e4eb',
};
const colorBgSecondary = {
  dark: '#141929',
  light: '#d3d3db',
};
const colorBgTertiary = {
  dark: '#1b2238',
  light: '',
};
const colorBgQuaternary = {
  dark: '#25304f',
  light: '#fff',
};
const colorBgContainer = {
  dark: '#0F131F',
  light: '#e4e4eb',
};
const colorBgSpotlight = {
  dark: '#141929',
  light: '#d3d3db',
};
const colorBgElevated = {
  dark: '#1b2238',
  light: '',
};
const colorBgElevatedContent = {
  dark: '#14151c',
  light: '#14151c',
};
const colorBgMask = {
  dark: '#0A0C14',
  light: '#fff',
};
const colorBgOverlay = {
  dark: '#00000000',
  light: 'rgba(36, 43, 63, 0.8)',
};
const colorBgDisabled = {
  light: '#272744',
  dark: '#272744',
};
const colorBorder = {
  dark: '#141929',
  light: '#141929',
};
const colorBorderTertiary = {
  dark: '#0a0a19',
  light: 'rgba(96, 113, 168, 0.35)',
};
const colorBorderAdditional = {
  dark: '#0a0a19',
  light: 'rgba(96, 113, 168, 0.8)',
};
const colorBorderDisabled = {
  dark: '#0a0a19',
  light: 'rgba(96, 113, 168, 0.35)',
};
const colorBorderSecondary = {
  dark: '',
  light: '',
};

export const neutralColorConfig: NeutralColorConfig = {
  colorTextBase,
  colorText,
  colorTextSecondary,
  colorTextTertiary,
  colorTextQuaternary,
  colorBgDefault,
  colorBgBase,
  colorBgContainer,
  colorBgSpotlight,
  colorBgElevated,
  colorBgElevatedContent,
  colorBg,
  colorBgSecondary,
  colorBgTertiary,
  colorBgQuaternary,
  colorBgMask,
  colorBgDisabled,
  colorBorder,
  colorBorderDisabled,
  colorBorderSecondary,
  colorBgOverlay,
  colorBorderTertiary,
  colorBorderAdditional,
};

export const neutralColorTokens: NeutralColorToken = {
  colorTextBase: setTheme(colorTextBase),
  colorText: setTheme(colorText),
  colorTextSecondary: setTheme(colorTextSecondary),
  colorTextTertiary: setTheme(colorTextTertiary),
  colorTextQuaternary: setTheme(colorTextQuaternary),
  colorBgDefault: setTheme(colorBgDefault),
  colorBgBase: setTheme(colorBgBase),
  colorBg: setTheme(colorBg),
  colorBgSecondary: setTheme(colorBgSecondary),
  colorBgTertiary: setTheme(colorBgTertiary),
  colorBgQuaternary: setTheme(colorBgQuaternary),
  colorBgContainer: setTheme(colorBgContainer),
  colorBgSpotlight: setTheme(colorBgSpotlight),
  colorBgElevated: setTheme(colorBgElevated),
  colorBgElevatedContent: setTheme(colorBgElevatedContent),
  colorBgMask: setTheme(colorBgMask),
  colorBgDisabled: setTheme(colorBgDisabled),
  colorBorder: setTheme(colorBorder),
  colorBorderDisabled: setTheme(colorBorderDisabled),
  colorBorderSecondary: setTheme(colorBorderSecondary),
  colorBgOverlay: setTheme(colorBgOverlay),
  colorBorderTertiary: setTheme(colorBorderTertiary),
  colorBorderAdditional: setTheme(colorBorderAdditional),
};
